import * as React from "react";

import { renderButton_unstable } from "@fluentui/react-components";

import type { RibbonButtonInternalProps } from "../RibbonButton.props";
import { useRibbonButton } from "./useRibbonButton";
import { useRibbonButtonStyles } from "./useRibbonButtonStyles.styles";
import type { RibbonButtonProps } from "./RibbonButton.types";
import { AppTooltipContainer } from "@1js/acui-tooltip";

/**
 * Define a styled `RibbonButton` using the `useRibbonButton` hook.
 */
export const RibbonButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonButtonInternalProps>(
    (props, ref) => {
      const state = useRibbonButton(
        {
          ...props,
          size: props.size?.toLowerCase() as RibbonButtonProps["size"],
        } as RibbonButtonProps,
        ref
      );

      // Apply styling.
      useRibbonButtonStyles(state);

      return (
        <AppTooltipContainer {...props}>
          {renderButton_unstable(state)}
        </AppTooltipContainer>
      );
    }
  )
);

RibbonButton.displayName = "next/RibbonButton";
